const vendorEn = {
    vendor: require('../../lang/en/vendor/Vendor').default,
};

export default vendorEn;

